import styled from 'styled-components';

import theme from './theme';

export const Badge = styled.div`
  display: inline-block;
  font-size: 0.875rem;
  text-transform: ${theme.textTransform};
  font-weight: ${Styles.fontWeight.heavy};
  font-family: ${Styles.fontFamily.body};
  text-shadow: none;
  padding: 2px 4px;
  margin-top: 4px;
`;
